export const users: TableModule = {
    name: "users",
    route: "spa.system.users",
    defaultOrder: {
        column: "lastname|firstname",
        direction: "asc"
    },
    columns: [
        {
            name: "customName",
            sortable: true,
            pageLink: true,
            sortBy: "lastname|firstname",
            mobile: true,
            width: "w-1/2 sm:w-auto"
        },
        {
            name: "email",
            sortable: true
        },
        {
            name: "role_name",
            truncate: false,
            mobile: true
        },
        {
            name: "last_login_at",
            sortable: true,
            width: "w-[150px]",
            breakpoint: "lg"
        }
    ],
    filters: [
        {
            name: "id",
            column: "users.id",
            type: "numeric",
            reduced: '[,]'
        },
        {
            name: "firstname",
            column: "users.firstname",
            type: "string"
        },
        {
            name: "lastname",
            column: "users.lastname",
            type: "string"
        },
        {
            name: "email",
            column: "users.email",
            type: "string",
            reduced: true
        },
        {
            name: "created_at",
            column: "users.created_at",
            type: "date",
        },
        {
            name: "last_login_at",
            column: "users.last_login_at",
            type: "date",
        }
    ],
    quickFilters: [],
    tools: [
        {
            name: "users.delete",
            color: "rose",
            icon: "delete"
        },
        {
            name: "users.create",
            isCreateAction: true,
            ability: [
                "create",
                "users"
            ]
        },
        {
            name: "general.export",
            ability: ["viewAny", "users"]
        }
    ]
}